import { render, staticRenderFns } from "./student-exchange.vue?vue&type=template&id=58c2c1fb"
import script from "./student-exchange.vue?vue&type=script&lang=js"
export * from "./student-exchange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports